import React from 'react';
import { Link } from 'gatsby';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Button } from 'reactstrap';
import logo from "../images/logo.svg"
import { MENU } from "../utils/enums";

export class Header extends React.Component {
    state = {
        isMenuVisible: false
    }

    toggle = () => {
        this.setState((state) => {
            return {isMenuVisible: !state.isMenuVisible}
        });
    }

    render() {
        console.log(this.props);
        return (
            <header>
                <Navbar light expand="md">
                    <div className="container p-0">

                        <Link to="/" className="navbar-brand">
                            <img src={logo} alt='logo' />
                        </Link>

                        <NavbarToggler onClick={this.toggle} />

                        <Collapse isOpen={this.state.isMenuVisible} navbar>
                            <Nav className="ml-auto" navbar>
                                {MENU.map((item) => {
                                    return <Link className="nav-link" key={item.path} to={item.path}>{item.label}</Link>
                                })}

                                <NavItem>
                                    <Button color="primary">book</Button>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>
            </header>
        )
    }
}

export default Header;
